<script lang="ts" setup>
const { fetchTranslatedDocument } = useTranslation()

const { data: page } = await fetchTranslatedDocument({
  document: '/product/faq',
  fields: [
    'banner',
    'body',
    'description',
    'title',
  ],
  key: 'product-faq',
})

useSeoMeta({
  description: page.value?.description,
  title: page.value?.title,
})
</script>

<template>
  <UContainer class="py-20">
    <UCard class="!p-0">
      <LayoutPageContent
        v-if="page"
        :page="page"
      />
    </UCard>
  </UContainer>
</template>
